//
//
//
//
//
//
//
//
//

import Media from './zy.media.js'

export default {
  props: {
    cover: String,
    video: String
  },
  beforeCreate () {
    this._player = Media(this.$el.querySelector('video'))
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/video/index.vue